import React from 'react';
import Button from '../ui/Button';
import './AdminHeader.css';

/**
 * Admin Header - Top navigation bar for admin dashboard
 */
const AdminHeader = ({ activeView, selectedTable, onBackToOverview, availableTables }) => {
  const getPageTitle = () => {
    if (activeView === 'table' && selectedTable) {
      const tableConfig = availableTables.find(t => t.key === selectedTable);
      return tableConfig ? `${tableConfig.label} Management` : 'Table Management';
    }

    switch (activeView) {
      case 'overview':
        return 'Dashboard Overview';
      case 'analytics':
        return 'Analytics & Reports';
      case 'settings':
        return 'System Settings';
      default:
        return 'Admin Dashboard';
    }
  };

  const getBreadcrumbs = () => {
    const breadcrumbs = [{ label: 'Admin', href: '#' }];

    if (activeView === 'table' && selectedTable) {
      breadcrumbs.push({ label: 'Overview', href: '#', onClick: onBackToOverview });

      const tableConfig = availableTables.find(t => t.key === selectedTable);
      if (tableConfig) {
        breadcrumbs.push({ label: tableConfig.label, href: '#' });
      }
    } else {
      breadcrumbs.push({ label: getPageTitle(), href: '#' });
    }

    return breadcrumbs;
  };

  return (
    <header className="admin-header">
      <div className="admin-header__content">
        <div className="admin-header__left">
          <nav className="admin-breadcrumb">
            {getBreadcrumbs().map((crumb, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="admin-breadcrumb__separator">/</span>}
                <button
                  className={`admin-breadcrumb__item ${
                    index === getBreadcrumbs().length - 1 ? 'active' : ''
                  }`}
                  onClick={crumb.onClick}
                  disabled={!crumb.onClick}
                >
                  {crumb.label}
                </button>
              </React.Fragment>
            ))}
          </nav>

          <h1 className="admin-header__title">{getPageTitle()}</h1>
        </div>

        <div className="admin-header__right">
          <div className="admin-header__user">
            <div className="admin-header__user-avatar">
              👤
            </div>
            <div className="admin-header__user-info">
              <div className="admin-header__user-name">Admin User</div>
              <div className="admin-header__user-role">Super Administrator</div>
            </div>
          </div>

          <Button variant="ghost" className="admin-header__logout">
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;